import { type ReactNode, Fragment } from 'react'

import type { CopySegment, ResolvedSignupModalCopy } from './copy'
import styles from './highlight-copy.module.scss'

export interface SignupModalHeaderCopy {
  title: ReactNode
  subtitle: ReactNode | null
}

export function buildSignupModalHeaderCopy(
  resolved: ResolvedSignupModalCopy
): SignupModalHeaderCopy {
  return {
    title: renderHighlightedTitle(resolved.titleSegments),
    subtitle: resolved.subtitleSegments
      ? renderHighlightedSubtitle(resolved.subtitleSegments)
      : null,
  }
}

function renderSegments(
  segments: CopySegment[],
  renderHighlight: (text: string, key: number) => ReactNode
): ReactNode {
  return segments.map((segment, index) =>
    segment.highlight ? (
      renderHighlight(segment.text, index)
    ) : (
      <Fragment key={index}>{segment.text}</Fragment>
    )
  )
}

export function renderHighlightedTitle(segments: CopySegment[]): ReactNode {
  return renderSegments(segments, (text, key) => (
    <span key={key} className={styles.entityName}>
      {text}
    </span>
  ))
}

export function renderHighlightedSubtitle(segments: CopySegment[]): ReactNode {
  return renderSegments(segments, (text, key) => (
    <strong key={key} className={styles.entityNameBold}>
      {text}
    </strong>
  ))
}
